import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';

export const StyledIconButton = styled.button`
  display: flex;
  gap: ${key('sizes.gap.tiny', '5px')};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${palette('background', 2)};
  color: ${palette('text', 0)};
  border: none;
  border-radius: ${key('sizes.borderRadius.tiny', '10px')};
  padding: 5px 20px;
  font-family: Space Grotesk Regular;
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.5;
          cursor: not-allowed !important;
          border: none !important;
        `
      : css``}
`;
